import React from "react"
import { RetinaImage } from "../../atoms/images/RetinaImage"
import { NotSmall, Small } from "../../atoms/Responsive"
import { Spacer } from "../../atoms/Atoms"
import { TextLink } from "../../atoms/links/TextLink"

const NavItem = ({ exact, link, text, onClick, id, leftPadding = true, onClickOnly = false }) => {
  const active = (exact && link === window.location.pathname) || (!exact && window.location.pathname.startsWith(link))
  const tickColor = active ? "b--carrot-orange" : "b--transparent"
  const paddingLeftSize = leftPadding ? "1.5rem" : null
  return (
    <TextLink underline={false} to={link} onClick={onClick} id={id} onClickOnly={onClickOnly}>
      <nav style={{ paddingLeft: paddingLeftSize, height: "1.5rem" }} className={`dib bl bw3 animate-all ${tickColor}`}>
        <span className={`f6 lh-copy dib v-mid no-underline gotham black-80 dim`}>{text}</span>
      </nav>
    </TextLink>
  )
}

const NavItemWithIcon = ({ icon, id, link, text }) => (
  <div className="flex " style={{ paddingLeft: "1.5rem" }}>
    <RetinaImage name={icon} height={24} width={24} />
    <NavItem id={id} link={link} text={text} leftPadding={false} />
  </div>
)

const NavIcon = ({ iconName }) => {
  const className = "pl4 db"

  return (
    <>
      <NotSmall>
        <RetinaImage height={32} width={32} className={className} name={iconName} />
      </NotSmall>
      <Small>
        <RetinaImage height={24} width={24} className={className} name={iconName} />
      </Small>
      <Spacer height={0.375} />
    </>
  )
}

export { NavItem, NavItemWithIcon, NavIcon }
